console.log('Howdy stranger');